import { SectionTitle } from "src/components/homepage/section-title";
import { components } from "src/strapi/schema";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "src/components/ui/carousel";
import { ReferenceBox } from "src/components/references/ReferenceBox";
import BlurFade from "src/components/ui/blur-fade";

export const InProgress = ({
  title,
  references,
}: {
  title: string;
  references: components["schemas"]["Reference"][];
}) => {
  return (
    <BlurFade inView>
      <SectionTitle title={title} />
      <Carousel
        opts={{
          align: "start",
          dragFree: true,
        }}
        className="md:mx-16"
      >
        <CarouselContent>
          {references.map((reference, index) => {
            return (
              <CarouselItem
                key={reference.id}
                className="basis-4/5 md:basis-1/2 lg:basis-1/3 xl:basis-1/4"
              >
                <BlurFade delay={0.1 * index}>
                  <ReferenceBox
                    className={
                      "h-[300px] w-full md:h-[290px] lg:h-[300px] xl:h-[330px]"
                    }
                    showYear={false}
                    mode={"compact"}
                    key={reference.id}
                    reference={reference}
                  />
                </BlurFade>
              </CarouselItem>
            );
          })}
        </CarouselContent>
        <CarouselPrevious />
        <CarouselNext />
      </Carousel>
    </BlurFade>
  );
};
